import axiosClient from "../axios-client";
import { getAllCouponSuccess } from "../reducers/couponPromotionReducer";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================

export const getAllCoupon = async (dispatch) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/coupon/list`)
        .then((res) => {
            dispatch(getAllCouponSuccess(res?.data || []))
        })
        .catch((error) => {
            toastMessage("Coupons not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// =================================== POST API ==================================
// ===============================================================================

export const createCouponCode = async (dispatch, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .post(`/coupon/create`, data)
        .then((res) => {
            toastMessage("Coupon code created successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Coupon code not created", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// =================================== PUT API ===================================
// ===============================================================================

export const updateCouponCode = async (dispatch, id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/coupon/update/${id}`, data)
        .then((res) => {
            toastMessage("Coupon data updated successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Coupon data not updated", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// =================================== DELETE API ================================
// ===============================================================================

export const deleteCouponCode = async (dispatch, id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .delete(`/coupon/delete/${id}`)
        .then((res) => {
            toastMessage("Coupon deleted successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Coupon code not deleted", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};

export const getSelectedCouponDetails = async (id) => {
    return axiosClient
        .get(`/coupon/get/${id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Coupons not found", "error")
            throw error;
        });
};

export const getReportTypesForCoupon = async () => {
    return axiosClient
        .get(`/report/report-types`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Report types not found", "error")
            throw error;
        })
};

export const getLiveAgentList = async () => {
    return axiosClient
        .get(`/agent/v2/agents?status=live`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Report types not found", "error")
            throw error;
        })
};
